/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import AssetPreview from 'shared/ui/components/uploader/AssetPreview.vue';
import SmartTable from 'shared/ui/components/tables/SmartTable.vue';
import UploadButton from 'shared/ui/components/uploader/UploadButton.vue';

const __vue_script__ = {
    name: 'AssetList',

    components: { AssetPreview, SmartTable, UploadButton },

    props: {
        event: {
            type: Object,
            required: true
        },

        assetsPerPage: {
            type: Number,
            required: false,
            default: 10
        },

        totalAssets: {
            type: Number,
            required: true
        },

        assets: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            editor: {},
            contents: [],
            metadata: null
        };
    },

    computed: {
        mimes() {
            return this.attachmentSpecs?.allowed_content_types?.length;
        },

        attachmentSpecs() {
            return this.$utils.metadata.getAttachmentSpecs(this.metadata);
        }
    },

    async created() {
        try {
            this.metadata = await this.$services.metadata.getMetadataForType(this.event._id, this.$services.documents.PRINTABLE_ASSET_TYPE);
        } catch (error) {
            console.error('[AssetList] Could not load proper metadata', error);
        }
    },

    methods: {
        /**
         * Go to the selected page
         *
         * @param {Number} page the page to select
         */
        pageChanged(page) {
            this.$emit('page-changed', page);
        },

        /**
         * Returns relative link
         *
         * @param {String} asset id of the asset
         *
         * @returns {String} relative link
         */
        getLink(asset) {
            const eventId = this.event._id;

            const controller = this.$services.blueprint.getControllerByName('assets-library', 'details') || {};
            return this.$services.blueprint.getLinkForModule(controller, { eventId, modelId: asset });
        },

        /**
         * Prompts the user with a deletion confirmation modal
         *
         * @param {object[]} assets a list of assets to prompt the deletion for
         */
        promptDelete(assets) {
            this.$modal.show('dialog', {
                text: this.$tc('asset_library.list.messages.prompt_deletes', assets.length),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.confirm'),
                        handler: async () => {
                            this.deleteAssets(assets);
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * Deletes the given assets
         *
         * @param {object[]} assets the assets to delete
         */
        async deleteAssets(assets) {
            try {
                const ids = assets.map(a => a.fp_ext_id);
                // @ts-ignore
                await this.$services.documents.deleteDocs(this.event._id, this.event.node, this.$services.documents.PRINTABLE_ASSET_TYPE, ids);

                this.$refs.table.unselectAll();
                this.pageChanged();

            } catch (error) {
                console.error('[AssetList] An error occurred', error.message || error);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('general.try_later').toString(),
                    type: 'error',
                    duration: 5000
                });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smart-table',{ref:"table",staticClass:"assets-list",attrs:{"items":_vm.assets,"editor":_vm.editor,"event":_vm.event,"total-items":_vm.totalAssets,"items-per-page":_vm.assetsPerPage,"selectable":true,"track-by":"_id"},on:{"next":_vm.pageChanged,"previous":_vm.pageChanged,"select-page":_vm.pageChanged},scopedSlots:_vm._u([{key:"actions",fn:function(ref){return [(_vm.mimes)?_c('upload-button',{staticClass:"btn-primary",attrs:{"scope":"asset-list","fp-type":_vm.$services.documents.PRINTABLE_ASSET_TYPE,"attachment-specs":_vm.attachmentSpecs},on:{"uploaded":function (data) { return _vm.$emit('update', data); }}}):_vm._e()]}},{key:"bulk-actions",fn:function(ref){
var selectedItems = ref.selectedItems;
return [_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.promptDelete(selectedItems)}}},[_vm._v(_vm._s(_vm.$t("asset_library.list.actions.delete")))])]}},{key:"headers",fn:function(ref){return [_c('th',{staticClass:"preview"},[_vm._v(_vm._s(_vm.$t("asset_library.list.headers.preview")))]),_c('th',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("asset_library.list.headers.title")))]),_c('th',{staticClass:"date"},[_vm._v(_vm._s(_vm.$t("asset_library.list.headers.upload_date")))]),_c('th',{staticClass:"size"},[_vm._v(_vm._s(_vm.$t("asset_library.list.headers.file_size")))]),_c('th',{staticClass:"type"},[_vm._v(_vm._s(_vm.$t("asset_library.list.headers.type")))]),_c('th',{staticClass:"row-actions"})]}},{key:"row",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"preview"},[_c('div',{staticClass:"outer-wrapper"},[_c('asset-preview',{attrs:{"asset":item,"event":_vm.event,"small":true}})],1)]),_c('td',{staticClass:"title ellipsis"},[_c('a',{attrs:{"href":_vm.getLink(item._id)}},[_vm._v(_vm._s(item.file_name))])]),_c('td',{staticClass:"date"},[_vm._v(_vm._s(_vm.$utils.time.tsToLongDateTimeFormat(item.timestamp)))]),_c('td',{staticClass:"filesize",class:{'error': item.upload_error}},[_vm._v(_vm._s(_vm.$utils.attachments.getSize(item, _vm.$i18n)))]),_c('td',{staticClass:"type"},[_vm._v(_vm._s(_vm.$utils.attachments.getHumanReadableMime(item)))]),_c('td',{staticClass:"row-actions"},[_c('button',{staticClass:"btn btn-danger btn-icon single",attrs:{"aria-label":_vm.$t('asset_library.list.actions.delete')},on:{"click":function($event){return _vm.promptDelete([item])}}},[_c('i',{staticClass:"ic-trash"})])])]}}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AssetsList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__